import ShieldDefault, { Shield as ShieldNamed } from "shield-ptr-npm";

let shieldInstance = null;
let initialized = false;

export async function initShield(siteId) {
  if (!siteId) throw new Error("Missing siteId for Shield");
  if (!shieldInstance) {
    const ShieldCtor = ShieldNamed || ShieldDefault;
    if (!ShieldCtor) {
      throw new Error("Shield export not found from shield-ptr-npm (neither named nor default)");
    }
    shieldInstance = new ShieldCtor();
  }
  if (!initialized) {
    await shieldInstance.init({ siteId });
    initialized = true;
  }
  return shieldInstance;
}

export async function getDeviceIntelligence(props = {}) {
  if (!shieldInstance || !initialized) {
    throw new Error("Shield not initialized");
  }
  return shieldInstance.getDeviceIntelligence(props);
}
